export const returnHourDate = (time: string) =>
  new Date().setHours(Number(time.slice(0, 2)), Number(time.slice(3, 5)));
